import { makeStyles } from '@epilot/journey-elements'

export const useStyles = makeStyles({
  badgeContainer: {
    padding: 0
  }
})
